import { useRef, useState } from 'react';
import '@/assets/styles/components/meet-connection-test.scss';
import MeetConnectionTestIframe from './meet-connection-iframe';
import MeetCameraHeader from './layouts/header.tsx';
import { MeetCameraBottom } from './layouts/bottom.tsx';
import { useNavigate } from 'react-router';

type MeetCameraRef = {
	onCameraStatus: () => void;
	onMicrophoneStatus: () => void;
};

const MeetCamera = () => {
	const meetWvRef = useRef<MeetCameraRef | null>(null);
	const [activeMicrophone, setActiveMicrophone] = useState<boolean>(true);
	const [activeVideoCamera, setActiveVideoCamera] = useState<boolean>(true);
	const navigate = useNavigate();

	const onCameraStatusToggle = () => {
		if (activeVideoCamera) {
			meetWvRef.current?.onCameraStatus(false);
			setActiveVideoCamera(false);
		} else {
			meetWvRef.current?.onCameraStatus(true);
			setActiveVideoCamera(true);
		}
	};

	const onMicrophoneStatusToggle = () => {
		if (activeMicrophone) {
			meetWvRef.current?.onMicrophoneStatus(false);
			setActiveMicrophone(false);
		} else {
			meetWvRef.current?.onMicrophoneStatus(true);
			setActiveMicrophone(true);
		}
	};

	const onLeaveTest = () => {
		if (window.history.state && window.history.state.idx > 0) {
			navigate(-1);
		} else {
			navigate('/', { replace: true });
		}
	};

	return (
		<div className="meet-connection-container">
			<MeetCameraHeader onLeave={onLeaveTest} />
			<MeetConnectionTestIframe
				ref={meetWvRef}
				src={process.env.DOPI_TECH_COMPONENTS_URL + '/#/video-connection-control'}
			/>
			<MeetCameraBottom
				activeVideoCamera={activeVideoCamera}
				activeMicrophone={activeMicrophone}
				toggleVideoCamera={onCameraStatusToggle}
				toggleMicrophone={onMicrophoneStatusToggle}
			/>
		</div>
	);
};

export default MeetCamera;
